import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class TabPreventionService {
  private readonly channelName = 'vts-tab-prevention';
  private readonly REPLY_WAIT_MS = 400;
  private readonly tabId = Math.random().toString(36).slice(2) + Date.now().toString(36);
  private channel: BroadcastChannel | null = null;
  private owner = false;
  private checked = false;

  // A new tab broadcasts "ping" and waits briefly. An already-open tab answers "pong".
  // Nothing is stored, so a closed/crashed browser can never leave a stale lock behind.
  isFirstTab(): boolean {
    if (this.checked) {
      return this.owner;
    }
    this.checked = true;

    if (typeof BroadcastChannel === 'undefined') {
      console.error('BroadcastChannel is not supported in this browser. Multiple tab prevention is disabled.');
      this.owner = true;
      return true;
    }

    this.channel = new BroadcastChannel(this.channelName);
    let blocked = false;

    this.channel.onmessage = (event: MessageEvent) => {
      const msg = event.data;
      if (!msg || msg.from === this.tabId) {
        return;
      }
      if (msg.type === 'ping' && this.owner) {
        this.channel.postMessage({ type: 'pong', from: this.tabId });
      } else if (msg.type === 'pong' && !this.owner) {
        blocked = true;
      }
    };

    this.channel.postMessage({ type: 'ping', from: this.tabId });

    setTimeout(() => {
      if (blocked) {
        this.channel.close();
        alert('Security Alerts. You cannot open this site in multiple tabs. This window will now close.');
        window.location.href = 'about:blank';
      } else {
        this.owner = true;
      }
    }, this.REPLY_WAIT_MS);

    return true;
  }
}
